module.exports = __webpack_public_path__ + "svg/new-amex-big.cfa2255207f3b7b23191238d2978642f.svg";